__turbopack_context__.v({
  "btn": "email-module-scss-module__zw6IyG__btn",
  "btn-alt": "email-module-scss-module__zw6IyG__btn-alt",
  "btn-default": "email-module-scss-module__zw6IyG__btn-default",
  "btn-default-dark-bg": "email-module-scss-module__zw6IyG__btn-default-dark-bg",
  "btn-disabled": "email-module-scss-module__zw6IyG__btn-disabled",
  "btn-elite": "email-module-scss-module__zw6IyG__btn-elite",
  "btn-gold": "email-module-scss-module__zw6IyG__btn-gold",
  "btn-lg": "email-module-scss-module__zw6IyG__btn-lg",
  "btn-link": "email-module-scss-module__zw6IyG__btn-link",
  "btn-plat": "email-module-scss-module__zw6IyG__btn-plat",
  "btn-primary": "email-module-scss-module__zw6IyG__btn-primary",
  "btn-sm": "email-module-scss-module__zw6IyG__btn-sm",
  "btn-success": "email-module-scss-module__zw6IyG__btn-success",
  "btn-warning": "email-module-scss-module__zw6IyG__btn-warning",
  "ccm": "email-module-scss-module__zw6IyG__ccm",
  "content": "email-module-scss-module__zw6IyG__content",
  "disabled": "email-module-scss-module__zw6IyG__disabled",
  "iia": "email-module-scss-module__zw6IyG__iia",
  "lead": "email-module-scss-module__zw6IyG__lead",
  "wrapper": "email-module-scss-module__zw6IyG__wrapper",
});
